import { ProposalStatus } from "src/store/models/proposalStatus.model";
import { undefinedIfDefault } from "./utils.defaultValues";

export const generateProposalClone = formValues => {
  const {
    productTypeID,
    specialistID,
    underwriterID,
    broker,
    isMultiLife,
    clients,
    hearAboutUsTypeID,
    originationTypeID,
    classifications,
    bpTypeID,
    epTypeID,
    payorTypeID,
    benefitAmount,
    isMaxBenefit,
    riders,
    statusTypeID,
    clientNote,
    isFiveCarrier,
  } = formValues;

  const completeClients = clients.map(c => {
    return {
      ...c,
      clientID: 0,
      prefixTypeID: undefinedIfDefault(c.prefixTypeID),
      genderTypeID: undefinedIfDefault(c.genderTypeID),
      tobaccoTypeID: undefinedIfDefault(c.tobaccoTypeID),
      tobaccoFrequencyID: undefinedIfDefault(c.tobaccoFrequencyID),
      isReplaceExistingCoverage: c.isReplaceExistingCoverage ? true : false,
    };
  });

  const proposal = {
    // no proposalID
    IsFromCloneProposal: true,
    productTypeID: undefinedIfDefault(productTypeID),
    specialistID: undefinedIfDefault(specialistID),
    underwriterID: undefinedIfDefault(underwriterID),
    brokerID: broker.brokerID,
    isMultiLife,
    clients: completeClients,
    hearAboutUsTypeID,
    originationTypeID,
    classifications: [],
    bpTypeID,
    epTypeID,
    payorTypeID,
    benefitAmount,
    isMaxBenefit,
    riders,
    statusTypeID: ProposalStatus.Unassigned,
    clientNote,
    isFiveCarrier,
    step: 0,
  };

  return proposal;
};
